/**
 * Ticker de USPs — Gudslip (Gudsport).
 * Marquee infinito robusto: rellena cada una de las 2 listas repitiendo sus ítems
 * hasta superar el ancho del viewport, de modo que el track (2 copias idénticas)
 * siempre sea > pantalla y el `translateX(-50%)` del CSS quede SIN costura ni hueco
 * a cualquier anchura. Ver NOTAS-DESARROLLO.md §3.4.
 */
(function () {
  'use strict';

  function fill(ticker) {
    if (ticker.classList.contains('iurop-ticker--static')) return;
    var vw = ticker.clientWidth || window.innerWidth || 0;
    if (!vw) return;
    var lists = ticker.querySelectorAll('.iurop-ticker__list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (list.dataset.base == null) list.dataset.base = list.innerHTML;
      list.innerHTML = list.dataset.base; // reset (por si es un resize)
      var guard = 0;
      // Repite el set de ítems hasta que UNA lista supere el viewport (con margen).
      while (list.scrollWidth < vw + 100 && guard < 40) {
        list.insertAdjacentHTML('beforeend', list.dataset.base);
        guard++;
      }
    }
  }

  function boot() {
    var tickers = document.querySelectorAll('.iurop-ticker');
    for (var i = 0; i < tickers.length; i++) fill(tickers[i]);
  }

  var timer;
  function onResize() {
    clearTimeout(timer);
    timer = setTimeout(boot, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', boot);
})();
